module.exports = __webpack_public_path__ + "static/media/backstage_palco_historias.f7021ad0.webp";